// const gateway = '/preview';
import fetch from '@/utils/axios';
import {api_url} from '@/global';


export const onlinePreview = (params) => fetch({
  params: params,
  url: `${api_url}/file/api/v1/preview/getViewUrlWebPath`
});


